const styles = {
	wrapper: {
		padding: ['40px 0', '50px 0'],
		marginBottom: ['0', '10px'],
		'.carousel-button-group button': {
			top: 'calc(50% - 34px)',
		},
	},
	header: {
		textAlign: 'center',
		marginBottom: ['30px', '40px'],
		h2: {
			color: 'primary',
			fontWeight: 600,
			fontSize: ['20px', '22px'],
			lineHeight: '1.4',
			marginBottom: '8px',
		},
		p: {
			fontSize: '14px',
		},
	},
};

export default styles;
